module.exports = __webpack_public_path__ + "img/zoom.6079e2ef.png";